app.ui.registerUi('nav', function(app) {
	var helpers = app.helpers.funcs;
	return {
        $elems: null,
		implementationExists: function() {
			return true; // implementation is entirely encapsulated within this file.
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {
            // initAll gets called in the mediator when modal pops up
			// We don't wnat this ui component to rerun it's init if 
            // we have already done it!
            if (this.$elems) {
                return;
            }
			this.$elems = helpers.resolveScope('#main-nav li', $scope);
            this.setUpMobileReveal();
            this.setUpFocusClassToggle();
            this.setUpHiddenChildDropdownClassToggle();
        },
        setUpMobileReveal: function () {
            var scope = this;
			scope.$elems.addClass('nav-opacity-hidden');
			$('#main-nav').on('show.bs.collapse', function () {
			    setTimeout(function() {
					var timeoutInc = 80;
					scope.$elems.each(function(k, elem) {
						var $elem = $(elem);
						var timeoutDuration = timeoutInc * k;
						setTimeout(function () {
						    $elem.removeClass('nav-opacity-hidden');
						}, timeoutDuration);
					});
				}, 150);
			});
			$('#main-nav').on('hide.bs.collapse', function () {
				$(this).find('li').addClass('nav-opacity-hidden');
			});
        },
        setUpFocusClassToggle: function () {
            var $elems = this.$elems;
            $elems.find('a').blur(function () {
                setTimeout(function () {
                    var $focused = $(':focus');
                    if (!$focused.closest('.navbar-right').length) {
                        $('#main-nav li').removeClass('focused');
                    }
                }, 1000);
            });
            $elems.find('a').focus(function () {
                $('#main-nav li').removeClass('focused');
                $(this).closest('.nav > li').addClass('focused');
            });
        },
        setUpHiddenChildDropdownClassToggle: function () {
            var timeoutKey = 'hidden-dropdown-timeout-handle';
            var $elems = this.$elems.filter('.dropdown');
            var $as = $elems.find(' > a');
            var $uls = $elems.find('.dropdown-menu');
            $uls.addClass('hidden-dropdown-menu');
            $as.on('mouseenter focus', function () {
                var t = $(this).data(timeoutKey);
                clearTimeout(t);
                $(this).data(timeoutKey, false);
                var $ul = $(this).parent().find('.dropdown-menu');
                $ul.removeClass('hidden-dropdown-menu');
            });
            $elems.on('mouseleave blur', function () {
                var $ul = $(this).find('.dropdown-menu');
                var $a = $(this).find('> a');
                var t = setTimeout(function () {
                    $ul.addClass('hidden-dropdown-menu');
                    $(this).data(timeoutKey, false);
                }, 500);
                $a.data(timeoutKey, t);
            });
        }
	};
});
